import { useProductCardFocused } from 'product-card/hooks/useProductCardFocused/useProductCardFocused'
import { useProductImageHovered } from 'product-card/hooks/useProductImageHovered/useProductImageHovered'
import { createContext, type ReactNode, useMemo } from 'react'

interface ProductCardInteractionContextProps {
	isUserInteractingWithProductCard: boolean
	handleMouseEnter: () => void
	handleMouseLeave: () => void
}

interface ProductCardInteractionProviderProps {
	readonly children: ReactNode
}

export const ProductCardInteractionContext =
	createContext<ProductCardInteractionContextProps | null>(null)

export const ProductCardInteractionProvider = ({
	children,
}: ProductCardInteractionProviderProps) => {
	const { isProductImageHovered, handleMouseEnter, handleMouseLeave } =
		useProductImageHovered()
	const isProductCardFocused = useProductCardFocused()

	const values = useMemo(
		() => ({
			isUserInteractingWithProductCard:
				isProductCardFocused || isProductImageHovered,
			handleMouseEnter,
			handleMouseLeave,
		}),
		[
			isProductCardFocused,
			isProductImageHovered,
			handleMouseEnter,
			handleMouseLeave,
		]
	)

	return (
		<ProductCardInteractionContext.Provider value={values}>
			{children}
		</ProductCardInteractionContext.Provider>
	)
}
